/* eslint-disable no-unused-expressions */
import('./bootstrap');
